import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isEditMode", "variant", "addText", "editText", "size"];
import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button';
function AddOrEditButton(_ref) {
  var isEditMode = _ref.isEditMode,
    variant = _ref.variant,
    addText = _ref.addText,
    editText = _ref.editText,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return isEditMode ? /*#__PURE__*/React.createElement(Button, _extends({
    icon: "edit",
    size: size,
    variant: variant
  }, otherProps), editText || t('actions_edit')) : /*#__PURE__*/React.createElement(Button, _extends({
    icon: "plus",
    size: size,
    variant: variant
  }, otherProps), addText || t('actions_add'));
}
export default AddOrEditButton;